import { ApolloClient, gql } from '@apollo/client';
import dayjs from 'dayjs';

export const getHostFunc = (apollo: ApolloClient<unknown>) => {
  return (hostId: number): { alias: string } | null =>
    apollo.readFragment<{ alias: string }>({
      id: apollo.cache.identify({
        __typename: 'HostOverview',
        id: hostId,
      }),
      fragment: gql`
        fragment HostAlias on HostOverview {
          alias
        }
      `,
    });
};

export const getFormattedTime = (date: string): string =>
  dayjs(date).format('D MMMM HH:mm');
